module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default", function() {
    return [(!_vm.content) ? _c('div', [(_vm.day > 0) ? _c('span', [_vm._v(_vm._s(_vm.day) + "天")]) : _vm._e(), (_vm.hour > 0) ? _c('span', [_vm._v(_vm._s(_vm.hour) + "时")]) : _vm._e(), (_vm.min > 0) ? _c('span', [_vm._v(_vm._s(_vm.min) + "分")]) : _vm._e(), (_vm.sec > 0) ? _c('span', [_vm._v(_vm._s(_vm.sec) + "秒")]) : _vm._e()]) : _c('div', [_vm._v("\n      " + _vm._s(_vm.content) + "\n    ")])]
  }, {
    "day": _vm.day,
    "hour": _vm.hour,
    "min": _vm.min,
    "sec": _vm.sec,
    "content": _vm.content
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a8f9517c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a8f9517c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/countdown/index.vue
// module id = 2905
// module chunks = 0